import React, { useState } from 'react'
import { useSelector, useDispatch, connect } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  withRouter
} from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { Container } from 'react-grid-system'

import { Button, LightGradient } from './adl'
import Menu, { MenuShownContext } from 'components/Menu'
import Header from 'components/Header'
import Branding from 'components/Branding'
import SystemAnnouncement from 'components/SystemAnnouncement'

import AccountsPage from './pages/Accounts'
import AccountDetailsPage from './pages/AccountDetails'
import BlankPage from './pages/Blank'
import CardsPage from './pages/Cards'
import CardDetailsPage from './pages/CardDetails'
import MoveMoneyPage from './pages/MoveMoney'
import SignInPage from './pages/SignIn'
import SignedOutPage from './pages/SignedOut'
import SpendingPage from './pages/Spending'
import StatementsPage from './pages/Statements'

import ThemePresets from './Presets'

import { store, persistor } from './store'

const staticPreset = process.env.REACT_APP_STATIC_PRESET

const Dashboard = () => {
  const [showMenu, setShowMenu] = useState(false)
  const isLoggedIn = useSelector(state => state.user.isLoggedIn)

  if (!isLoggedIn) {
    return <Redirect to="/sign-in" />
  }

  return (
    <div style={{ height: '100%' }}>
      <LightGradient style={{ minHeight: '100%' }}>
        <Switch>
          <Route path="/alerts" component={BlankPage} />
          <Route path="/budgeting" component={BlankPage} />
          <Route path="/contact-us" component={BlankPage} />
          <Route path="/download-transactions" component={BlankPage} />
          <Route path="/goals" component={BlankPage} />
          <Route path="/locations" component={BlankPage} />
          <Route path="/profile" component={BlankPage} />
          <Route path="/reorder-checks" component={BlankPage} />
          <Route path="/secure-messages" component={BlankPage} />
          <Route path="/settings" component={BlankPage} />
          <Route path="/statements" component={StatementsPage} />
          <Route path="/stop-checks" component={BlankPage} />
          <Route path="/transactions" component={BlankPage} />

          <Route path="/move-money" component={MoveMoneyPage} />
          <Route path="/spending" component={SpendingPage} />
          <Route path="/card-details/:id" component={CardDetailsPage} />
          <Route path="/account-details/:id" component={AccountDetailsPage} />
          <Route path="/accounts" component={AccountsPage} />
          <Route path="/cards" component={CardsPage} />
        </Switch>
      </LightGradient>
      <MenuShownContext.Provider value={showMenu}>
        <Menu onHide={() => setShowMenu(false)} />
        <Header onMenuClicked={() => setShowMenu(true)} />
      </MenuShownContext.Provider>
    </div>
  )
}

class ErrorBoundary extends React.Component {
  state = {
    hasError: false
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo)
  }

  render() {
    const { logout, history } = this.props

    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Container>
          <h3>Something went wrong.</h3>
          <Button
            onClick={() => {
              logout()
              history.replace('/sign-in')
              this.setState({ hasError: false })
            }}
          >
            Reset
          </Button>
        </Container>
      )
    }

    return this.props.children
  }
}

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch({ type: 'USER_LOGOUT' })
})

ErrorBoundary = connect(null, mapDispatchToProps)(withRouter(ErrorBoundary))

function ThemedApp() {
  let preset = useSelector(
    state =>
      ThemePresets.find(p => p.label === state.preset.presetName) ||
      ThemePresets[0]
  )
  if (staticPreset) {
    preset = ThemePresets.find(p => p.label === staticPreset) || preset
  }

  const showAnnouncement = useSelector(state => state.user.showAnnouncement)

  const dispatch = useDispatch()

  return (
    <ThemeProvider theme={preset.theme}>
      <Router>
        <ErrorBoundary>
          <SystemAnnouncement
            onHide={() =>
              dispatch({
                type: 'HIDE_ANNOUNCEMENT'
              })
            }
            visible={showAnnouncement}
            message="Due to COVID-19, many of our locations are currently closed for your safety. We are working with local authorities to coordinate a safe return to business."
          />

          <Switch>
            <Route path="/sign-in" component={SignInPage} />
            <Route path="/signed-out" component={SignedOutPage} />
            {/*
    <Route path="/sign-up" component={SignUpPage} />
    <Route path="/trouble-signing-in" component={TroubleSigningInPage} />
    <Route path="/verify-information" component={VerifyInformationPage} />

    */}
            <Redirect path="/" exact to="/accounts" />
            <Route path="*" component={Dashboard} />
          </Switch>

          {!staticPreset && (
            <Branding
              presets={ThemePresets}
              currentPreset={preset}
              onChange={newPreset =>
                dispatch({
                  type: 'APPLY_PRESET_NAME',
                  payload: newPreset.label
                })
              }
            />
          )}
        </ErrorBoundary>
      </Router>
    </ThemeProvider>
  )
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemedApp />
      </PersistGate>
    </Provider>
  )
}

export default App
